module.exports = __webpack_public_path__ + "img/Recurso 17-100.1e29de83.jpg";